module.exports = __webpack_public_path__ + "static/media/logos_50h_worldGreen.a47a3ef1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/conf/logo_bar/logos_50h_worldGreen.jpg
// module id = 230
// module chunks = 0